<template>
  <div>
    <h1 class="text-center primary--text">Game #{{gameNum}} of {{totalGames}}</h1>
    <div v-if="groupGamesLoaded">
      <v-card class="mt-3 py-3">
        <v-text-field class="mx-5 mb-n5" @change="entryChanged=true" type="date" 
          ref="gameDate" v-model="gameList[gameNum-1].gameDate" label="Game Date" />
        <v-text-field class="mx-5 mb-n5" @change="entryChanged=true" 
          ref="gameVenue" v-model="gameList[gameNum-1].gameVenue" label="Game Venue" />
        <v-select class="mx-5 mb-n5" 
          label="Team A" ref="memberA" @change="entryChanged=true"
          :items="tourGroups[0].groupMembers"
          v-model="gameList[gameNum-1].memberA">
        </v-select>
        <v-text-field class="mx-5 mb-n5" @change="entryChanged=true" type="number" 
          ref="oddA" v-model="gameList[gameNum-1].oddA" label="Odds for A" />
        <v-select class="mx-5 mb-n5" 
          label="Team B" ref="memberB" @change="entryChanged=true"
          :items="tourGroups[0].groupMembers"
          v-model="gameList[gameNum-1].memberB">
        </v-select>
        <v-text-field class="mx-5" @change="entryChanged=true" type="number" 
          ref="oddB" v-model="gameList[gameNum-1].oddB" label="Odds for B" />
        <v-row class="mx-5">
          <v-btn color="primary" outlined @click="goPrev">
            <v-icon color="primary">mdi-skip-previous</v-icon>
            Prev
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" outlined @click="goNext">
            Next
            <v-icon color="primary">mdi-skip-next</v-icon>
          </v-btn>
        </v-row>
      </v-card>
      <v-row class="mt-3">
        <v-btn color="success" outlined @click="newGameBefore">Add Game Before</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="success" outlined @click="newGameAfter">Add Game After</v-btn>
      </v-row>
      <v-row class="my-3">
        <v-spacer></v-spacer>
        <v-btn color="error" outlined @click="deleteGame">Delete Game</v-btn>
        <v-spacer></v-spacer>
      </v-row>
      <v-row>
        <v-spacer></v-spacer>
        <v-btn color="success" @click="saveGames">Save</v-btn>
        <v-spacer></v-spacer>
      </v-row>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import axios from 'axios'

export default {
  name: 'groupGames',
  props: [
    'tourId', 'groupId',
  ],
  computed: {
    ...mapGetters([
      'tourGroups', 'tourGroupsLoaded', 'groupGames', 'groupGamesLoaded'
    ])
  },
  created() {
    this.$store.dispatch('getTourGroups', this.tourId)
    this.$store.dispatch('getGroupGames', this.groupId)
  },
  watch: {
    groupGamesLoaded: function() {
      if (this.groupGames.length > 0) {
        this.gameList = this.groupGames.slice()
        for (var i=0; i< this.gameList.length; i++) {
          this.gameList[i].gameDate = this.gameList[i].gameDate.substring(0, 10)
        }
        this.totalGames = this.groupGames.length
      } else {
        this.gameList.splice(0)
        var game = {
          gameNum: 1,
          memberA: '',
          oddA: 0.0,
          memberB: '',
          oddB: 0.0,
          gameDate: '',
          gameVenue: '',
          groupId: this.groupId,
          tournamentId: this.tourId
        }
        this.gameList.push(game)
        this.totalGames = 1
      }
    }
  },
  data: () => ({
    gameList: [],
    gameNum: 1,
    totalGames: 1,
    gameDeleted: false,
    entryChanged: false,
  }),
  methods: {
    goPrev() {
      if (this.gameNum == 1) {
        if (this.entryChanged) {
          if (this.checkGameFields()) {
            this.saveGames()
          } else {
            return
          }
        }
        this.$emit('message', '')
      } else {
        this.gameNum --
      }
    },
    goNext() {
      if (this.entryChanged) {
        if (!this.checkGameFields()) {
          return
        }
      }
      if (this.gameNum < this.totalGames) {
        this.gameNum ++
        this.entryChanged = false
      }
    },
    checkGameFields() {
      if (this.gameList[this.gameNum-1].gameDate == '') {
        alert('Enter Game Date')
        this.$refs.gameDate.focus()
        return false
      }
      this.gameList[this.gameNum-1].gameVenue.trim()
      if (this.gameVenue == '') {
        alert ("Enter Game Venue")
        this.$refs.gameVenue.focus()
        return false
      }
      if (this.gameList[this.gameNum-1].memberA == '') {
        alert ("Enter Team-A")
        this.$refs.memberA.focus()
        return false
      }
      if (this.gameList[this.gameNum-1].memberB == '') {
        alert ("Enter Team-B")
        this.$refs.memberB.focus()
        return false
      }
      if (this.gameList[this.gameNum-1].oddA == 0.0) {
        alert ("Enter Odds for Team-A")
        this.$refs.oddA.focus()
        return false
      }
      if (this.gameList[this.gameNum-1].oddB == 0.0) {
        alert ("Enter Odds for Team-B")
        this.$refs.oddB.focus()
        return false
      }      
      return true
    },
    newGameAfter() {
      if (this.entryChanged) {
        if (!this.checkGameFields()) {
          return
        }
      }
      var game = {
        gameNum: this.gameNum + 1,
        memberA: '',
        oddA: 0.0,
        memberB: '',
        oddB: 0.0,
        gameDate: '',
        gameVenue: '',
        groupId: this.groupId,
        tournamentId: this.tourId
      }
      this.gameList.splice(this.gameNum, 0, game)
      this.gameNum ++
      this.totalGames ++
    },
    newGameBefore() {
      if(this.entryChanged) {
        if (!this.checkGameFields()) {
          return
        }
      }
      var game = {
        gameNum: this.gameNum,
        memberA: '',
        oddA: 0.0,
        memberB: '',
        oddB: 0.0,
        gameDate: '',
        gameVenue: '',
        groupId: this.groupId,
        tournamentId: this.tourId
      }
      this.gameList.splice(this.gameNum - 1, 0, game)
      this.totalGames ++
    },
    deleteGame() {
      if (this.totalGames == 1) {
        this.setupEmptyGame()
        return
      }
      this.gameList.splice(this.gameNum - 1, 1)
      this.entryChanged = true
      this.gameDeleted = true
      this.totalGames --
      this.populateGame()
    },
    saveGroupGames() {
      const token = this.$store.getters.authToken
      const header = { 'Content-type': 'application/json', 'x-auth': token }
      var i = 0
      for (i=0; i < this.gameList.length; i++) {
        this.gameList[i].gameNum = i + 1
        this.gameList[i].oddA = Number(this.gameList[i].oddA)
        this.gameList[i].oddB = Number(this.gameList[i].oddB)
        axios.post('/api/groupGame', JSON.stringify(this.gameList[i]), { headers: header })
        .catch(function(err) {
          alert(err.response.data.err)
        })
      }
    },
    saveGames() {
      const token = this.$store.getters.authToken
      const header = { 'Content-Type': 'application/json', 'x-auth': token }
      var self = this
      if (this.gameDeleted) {
        var objGroup = { groupId: this.groupId }
        axios.post('/api/delGroupGames', JSON.stringify(objGroup), { headers: header })
        .then(() => {
          self.gameDeleted = false
          self.saveGroupGames()
        })
        .catch(err => {
          alert(err.response.data.err)
        })
      } else {
        this.saveGroupGames()
      }
    }
  }
}
</script>